'use client';

import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics, TrackedItem} from '../../analytics';
import {useLocale} from '../../i18n';
import type {UnitTypeCardView} from '../../model';
import {unitHref} from '../../routing';
import {ListingCarousel} from '../listing';
import {Section} from '../primitives';
import {UnitTypeCard} from './UnitTypeCard';

export interface DetailUnitTypesCarouselProps {
  units: UnitTypeCardView[];
  analytics: DetailPageAnalytics;
  parentTracked: TrackedItem;
  onRegisterInterest: (unit: UnitTypeCardView) => void;
  viewAllHref?: string;
}

export function DetailUnitTypesCarousel({units, analytics, parentTracked, onRegisterInterest, viewAllHref}: DetailUnitTypesCarouselProps) {
  const {t} = useTranslation();
  const locale = useLocale();
  if (units.length === 0) {
    return null;
  }

  return (
    <Section tone="subtle">
      <ListingCarousel
        title={t('unit_types')}
        viewAll={
          viewAllHref
            ? {
                label: t('view_all'),
                href: viewAllHref,
                onClick: () => {
                  analytics.viewAll(parentTracked, 'unit_types');
                },
              }
            : undefined
        }
      >
        {units.map(unit => (
          <UnitTypeCard
            key={unit.uuid}
            unit={unit}
            href={unitHref(locale, unit.uuid)}
            analytics={analytics}
            onRegisterInterest={onRegisterInterest}
          />
        ))}
      </ListingCarousel>
    </Section>
  );
}

DetailUnitTypesCarousel.displayName = 'DetailUnitTypesCarousel';
